/* Change this file to get your personal Portfolio */

// Website related settings
const settings = {
  isSplash: true, // Assuming a splash screen for a professional portfolio
};

// SEO Related settings
const seo = {
  title: "Michael Ragan's Portfolio",
  description:
    "A seasoned Full Stack Engineer with 16 years of experience building scalable systems and user-friendly interfaces for Fintech and enterprise applications.",
  og: {
    title: "Michael Ragan Portfolio",
    type: "website",
    url: "http://www.ragan.pro/", // Placeholder URL, as no personal website is provided
  },
};

// Home Page
const greeting = {
  title: "Michael Ragan",
  logo_name: "Michael Ragan",
  nickname: "Mike", // Assumed based on name
  subTitle:
    "A seasoned Full Stack Engineer with 16 years of experience building scalable systems and user-friendly interfaces for Fintech and enterprise applications. Passionate about mentoring teams and delivering impactful AI-driven solutions.",
  resumeLink: "../resumes/Mike Ragan-Staff-Resume.pdf", // No resume link provided in the document
  portfolio_repository: "https://github.com/michaelr260/portfolio", // No GitHub portfolio repository provided
  githubProfile: "https://github.com/michaelr260", // No GitHub profile provided
};

// Social Media Links
const socialMediaLinks = [
  {
    name: "LinkedIn",
    link: "https://linkedin.ragan.pro", // Placeholder, as LinkedIn URL is mentioned but not specific
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Email",
    link: "mailto:michael@ragan.pro",
    fontAwesomeIcon: "fas fa-envelope-open-text",
    backgroundColor: "#D14836",
  },
];

// Skills Section
const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive web applications using React, Next.js, and TypeScript",
        "⚡ Developing scalable microservices with Node.js and Python",
        "⚡ Creating user-friendly interfaces with Redux, HTML, and CSS",
      ],
      softwareSkills: [
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: { color: "#ffffff" },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: { color: "#3178C6" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: { backgroundColor: "#000000", color: "#F7DF1E" },
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: { color: "#339933" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: { backgroundColor: "transparent", color: "#3776AB" },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: { color: "#E34F26" },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: { color: "#1572B6" },
        },
      ],
    },
    {
      title: "Backend Development & APIs",
      fileName: "BackendImg", // Assumed image name
      skills: [
        "⚡ Architecting scalable microservices with Node.js and TypeScript",
        "⚡ Building efficient GraphQL and RESTful APIs for seamless data retrieval",
        "⚡ Managing databases like PostgreSQL, MongoDB, and MySQL",
      ],
      softwareSkills: [
        {
          skillName: "Node.js",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: { color: "#339933" },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: { color: "#E10098" },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: { color: "#336791" },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: { color: "#47A248" },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: { color: "#4479A1" },
        },
        {
          skillName: "DynamoDB",
          fontAwesomeClassname: "simple-icons:amazondynamodb",
          style: { color: "#4053D6" },
        },
      ],
    },
    {
      title: "Cloud & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Deploying applications on AWS with Docker and Kubernetes",
        "⚡ Optimizing CI/CD pipelines for faster deployments",
        "⚡ Ensuring high availability and scalability with cloud infrastructure",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#1488C6" },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: { color: "#326CE5" },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: { color: "#F05032" },
        },
      ],
    },
    {
      title: "Testing & Automation",
      fileName: "TestingImg", // Assumed image name
      skills: [
        "⚡ Writing end-to-end tests with Playwright for reliable applications",
        "⚡ Implementing unit and integration tests with Jest",
        "⚡ Automating workflows to enhance productivity",
      ],
      softwareSkills: [
        {
          skillName: "Playwright",
          fontAwesomeClassname: "simple-icons:playwright",
          style: { color: "#2EAD33" },
        },
        {
          skillName: "Jest",
          fontAwesomeClassname: "simple-icons:jest",
          style: { color: "#C21325" },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [], // No competitive coding profiles provided in the resume
};

const degrees = {
  degrees: [
    {
      title: "DeVry University",
      subtitle: "B.S. in Computer Science",
      logo_path: "devry_logo.png", // Assumed logo
      alt_name: "DeVry University",
      duration: "2002 - 2007",
      descriptions: [
        "⚡ Studied core computer science subjects including Object-Oriented Programming, Java Development, and Digital Logic",
        "⚡ Developed a strong foundation in software engineering principles",
      ],
      website_link: "https://www.devry.edu/",
    },
  ],
};

const certifications = {
  certifications: [], // No certifications listed in the resume
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have 16 years of experience as a Full Stack Engineer, working on Fintech platforms and enterprise tools at companies like Convera and Oracle. I specialize in React, Node.js, and cloud technologies, with a passion for mentoring teams and building scalable, user-focused solutions.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Senior Software Engineer - Tech Lead",
          company: "Convera",
          company_url: "https://www.convera.com/",
          logo_path: "convera_logo.png", // Assumed logo
          duration: "Jan 2024 - Present",
          location: "New York, NY, USA (Remote)",
          description:
            "Designed and deployed React and Next.js-based microfrontends for payment and reporting flows, enhancing user experience and system modularity. Architected scalable Node.js microservices using TypeScript and MongoDB on AWS. Built a GraphQL module to optimize data retrieval by 25%. Mentored junior developers, optimized CI/CD pipelines with Docker, and enhanced Playwright tests for 99.9% uptime.",
          color: "#000000",
        },
        {
          title: "Principal Software Developer",
          company: "Oracle Corporation",
          company_url: "https://www.oracle.com/",
          logo_path: "oracle_logo.png",
          duration: "Feb 2017 - Jan 2024",
          location: "New York, NY, USA (Remote)",
          description:
            "Led React and TypeScript-based development for high-traffic web applications. Developed a Node.js-based chatbot with MongoDB, reducing support tickets by 47%. Mentored teams on Agile and TypeScript practices. Created a TypeScript-based GUI with Oracle JET and deployed OAuth/SAML SSO across 10+ applications using Docker.",
          color: "#0879bf",
        },
        {
          title: "Senior Software Engineer",
          company: "Oracle Corporation",
          company_url: "https://www.oracle.com/",
          logo_path: "oracle_logo.png",
          duration: "Jul 2013 - Feb 2017",
          location: "Angelica, NY, USA (Remote)",
          description:
            "Built a PL/SQL-based SEO project with XML enhancements, improving data visibility. Developed an Adobe Flex-based WYSIWYG app, boosting productivity by 20%.",
          color: "#9b1578",
        },
        {
          title: "Software Developer",
          company: "Oracle",
          company_url: "https://www.oracle.com/",
          logo_path: "oracle_logo.png",
          duration: "Jan 2010 - Jul 2013",
          location: "Angelica, NY, USA (Remote)",
          description:
            "Created a JavaScript-based library for SPAs, reducing development time by 70% (48 to 12 hours). Launched a PHP-based video streaming service with MySQL, enhancing internal communications.",
          color: "#fc1f20",
        },
        {
          title: "Technical Support Engineer",
          company: "Primavera (Acquired by Oracle)",
          company_url: "https://www.oracle.com/",
          logo_path: "primavera_logo.png", // Assumed logo
          duration: "Oct 2008 - Jan 2010",
          location: "Angelica, NY, USA (Remote)",
          description:
            "Automated migration tasks during Oracle's acquisition of Primavera, streamlining integration. Collaborated with engineers to resolve complex issues, boosting customer satisfaction.",
          color: "#4285F4",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [], // No internships listed in the resume
    },
    {
      title: "Volunteerships",
      experiences: [], // No volunteerships listed in the resume
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects leverage modern technologies like React, Node.js, and AWS to build scalable and user-focused solutions for Fintech and enterprise applications.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "No publications listed.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [], // No publications provided in the resume
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "michaelragan.svg", // Assumed image
    description:
      "I'm available via email and LinkedIn. Feel free to reach out for collaboration on Full Stack Development, AI-driven solutions, or cloud-based projects. I typically reply within 24 hours.",
  },
  blogSection: {
    title: "Blogs",
    subtitle: "No blogs listed.",
    link: "", // No blog link provided
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Location",
    subtitle: "Remote, USA",
    locality: "USA",
    country: "USA",
    region: "",
    postalCode: "", // No postal code provided
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/", // No specific map link provided
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+1 (610) 657-6356",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
